import i18n from '@/i18n'

export const TIERS_COLORS = {
  1: '#16969d',
  2: '#ffcd03',
  3: '#4b565f'
}

export const CATEGORY_COLORS = ['9d', 'a3', '61', '42']

export const DONUT_CHART_CONFIG = {
  tooltip: {
    trigger: 'item',
    valueFormatter: (value) => new Intl.NumberFormat('it-IT').format(value)
  },
  legend: {
    bottom: '0',
    left: 'center',
    selectedMode: false
  },
  grid: {
    left: '10%',
    top: 0,
    right: '10%',
    bottom: 0
  },
  series: [
    {
      name: i18n.t('INVESTMENT'),
      type: 'pie',
      radius: ['40%', '60%'],
      avoidLabelOverlap: false,
      label: {
        show: true,
        formatter (param) {
          return `${param.name} ${param.percent}%`
        }
      },
      labelLine: {
        show: true,
        showAbove: false,
        length: 8,
        length2: 0
      },
      data: null,
      cursor: 'default'
    }
  ]
}

export const VERTICAL_BAR_STACKED_CONFIG_IMPRESSIONS = {
  xAxis: {
    type: 'value',
    axisTick: {
      show: false
    }
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      // Use axis to trigger tooltip
      type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
    },
    valueFormatter: (value) => new Intl.NumberFormat('it-IT').format(value)
  },
  legend: {},
  grid: {
    left: '0',
    right: '10%',
    bottom: '0',
    top: '0',
    containLabel: true
  },
  yAxis: {
    type: 'category',
    data: null
  },
  series: [
    {
      label: {
        show: false,
        position: 'insideRight'

      },
      data: null,
      type: 'bar',
      cursor: 'default'
    }
  ]
}

export const VERTICAL_BAR_STACKED_CONFIG_CLICKS = {
  xAxis: {
    type: 'value',
    axisTick: {
      show: false
    }
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      // Use axis to trigger tooltip
      type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
    },
    valueFormatter: (value) => new Intl.NumberFormat('it-IT').format(value)
  },
  legend: {},
  grid: {
    left: '0',
    right: '10%',
    bottom: '0',
    top: '0',
    containLabel: true
  },
  yAxis: {
    type: 'category',
    data: null
  },
  series: [
    {
      label: {
        show: false,
        position: 'insideRight'

      },
      data: null,
      type: 'bar',
      cursor: 'default'
    }
  ]
}

export const VERTICAL_BAR_STACKED_CONFIG_VISITS = {
  xAxis: {
    type: 'value',
    axisTick: {
      show: false
    }
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      // Use axis to trigger tooltip
      type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
    },
    valueFormatter: (value) => new Intl.NumberFormat('it-IT').format(value)
  },
  legend: {},
  grid: {
    left: '0',
    right: '10%',
    bottom: '0',
    top: '0',
    containLabel: true
  },
  yAxis: {
    type: 'category',
    data: null
  },
  series: [
    {
      label: {
        show: false,
        position: 'insideRight'

      },
      data: null,
      type: 'bar',
      cursor: 'default'
    }
  ]
}

export const VERTICAL_BAR_STACKED_CONFIG_CTR = {
  xAxis: {
    type: 'value',
    axisTick: {
      show: false
    }
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      // Use axis to trigger tooltip
      type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
    },
    valueFormatter: (value) => new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(value)
  },
  legend: {},
  grid: {
    left: '0',
    right: '10%',
    bottom: '0',
    top: '0',
    containLabel: true
  },
  yAxis: {
    type: 'category',
    data: null
  },
  series: [
    {
      label: {
        show: false,
        position: 'insideRight'

      },
      emphasis: {
        focus: 'series'
      },
      data: null,
      type: 'bar',
      cursor: 'default'
    }
  ]
}

export const HORIZONTALL_BAR_STACKED_CONFIG = {
  title: {
    left: 'left',
    text: ''
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      // Use axis to trigger tooltip
      type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
    },
    formatter: function (params) {
      let tooltipContent = '<div style="width: auto">'
      params.forEach(function (item) {
        tooltipContent += `
        <div style="display:flex; flex-direction: row; gap: 8px; justify-content: space-between;">
          <div style="display:flex; flex-direction: row; gap: 8px; justify-content: flex-start;">
            <div>${item.marker}</div>
            <div> ${item.seriesName}</div>
          </div>
          <div>
            <div style="font-weight: 600"><strong>${new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(item.value)}</strong></div>
          </div>
        </div>`
      })
      return tooltipContent + '</div>'
    }
  },
  legend: {
    bottom: '0',
    left: 'center'
  },
  grid: {
    left: '6%',
    right: '2%',
    bottom: '10%',
    top: '4%',
    containLabel: true
  },
  xAxis: {
    type: 'category',
    data: null
  },
  yAxis: {
    type: 'value'
  },
  series: null
}

// Italian months
export const MONTHS = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic']
